globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.Counter = (function() {

  Counter.selector       = '[data-plugin="counter"]';
  Counter.defaultOptions = {
    start: 5,
    end: 0,
    interval: 1000
  }

  function Counter($html) {
    this.$html     = $html;
    this.$counter  = this.$html.find(".counter.counter-count");
    this.options   = $.extend(Counter.defaultOptions, this.$html.data("plugin-options"));
    this.direction = this.setCounterDirection();
    this.init();
  }

  Counter.init = function($html) {
    $html.find(Counter.selector).each(function(){
      new Counter($(this));
    })
  }

  Counter.prototype = {
    init: function() {
      var _this = this;
      _this.$counter.text(_this.options.start.toString());
      _this.events();
      _this.startCounter();
    },
    events: function() {
      var _this = this;

      if(_this.options.container_to_hide_selector) {
        _this.$html.on("counter_finished", function() {
          $('body').find(_this.options.container_to_hide_selector).fadeOut();
        });
      }
    },
    startCounter: function() {
      var _this   = this,
          counter = _this.options.start;

      var countDown = setInterval(function() {
        _this.direction == "down" ? counter-- : counter++
        _this.$counter.text(counter.toString());
        if(counter === _this.options.end) {
          clearInterval(countDown);
          _this.$html.trigger("counter_finished");
        }
      }, _this.options.interval);
    },
    setCounterDirection: function() {
      var _this = this;
      return _this.options.start > _this.options.end ? "down" : "up"
    }
  }

  return Counter;

})();
